document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-product-card]').forEach(function (card) {
    var jsonEl = card.querySelector('.product-variants-json');
    var colorWrap = card.querySelector('[data-color-options]');
    var sizeWrap = card.querySelector('[data-size-options]');
    var quickShopTrigger = card.querySelector('.product-details-icon');

    if (!jsonEl || !sizeWrap) return;

    var variants = [];
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var colorButtons = colorWrap
      ? Array.prototype.slice.call(colorWrap.querySelectorAll('.color-option'))
      : [];

    var allSizeValues = Array.prototype.slice.call(
      sizeWrap.querySelectorAll('.size-option')
    ).map(function (el) {
      return el.getAttribute('data-size-value');
    });

    var selectedColorEl = colorWrap
      ? colorWrap.querySelector('.color-option.is-selected')
      : null;

    var selectedColor = selectedColorEl
      ? selectedColorEl.getAttribute('data-color-value')
      : null;

    var selectedSize = sizeWrap.getAttribute('data-selected-size') || null;
    var hasColorOption = sizeWrap.getAttribute('data-has-color-option') === 'true';

    function isOutOfStock(variant) {
      if (!variant) return true;
      if (variant.available === false) return true;
      if (Number(variant.inventory_quantity || 0) <= 0) return true;
      return false;
    }

    function getVariant(color, size) {
      return variants.find(function (variant) {
        if (hasColorOption) {
          return variant.option1 === color && variant.option2 === size;
        } else {
          return variant.option1 === size;
        }
      });
    }

    function getSelectedSizeEl() {
      return sizeWrap.querySelector('.size-option.is-selected');
    }

    function syncCardSelectionData() {
      var selectedEl = getSelectedSizeEl();

      if (!selectedEl) {
        card.removeAttribute('data-selected-size');
        card.removeAttribute('data-selected-stock');
        card.removeAttribute('data-selected-variant-id');
        return;
      }

      card.setAttribute('data-selected-size', selectedEl.getAttribute('data-size-value') || '');
      card.setAttribute('data-selected-stock', selectedEl.getAttribute('data-size-stock') || '');
      card.setAttribute('data-selected-variant-id', selectedEl.getAttribute('data-variant-id') || '');
    }

    function updateQuickShopState() {
      if (!quickShopTrigger) return;

      var hasAvailableSize = Array.prototype.slice.call(
        sizeWrap.querySelectorAll('.size-option')
      ).some(function (el) {
        return Number(el.getAttribute('data-size-stock') || 0) > 0;
      });

      if (hasAvailableSize) {
        quickShopTrigger.classList.remove('is-disabled', 'is-sold-out');
        quickShopTrigger.removeAttribute('aria-disabled');
        quickShopTrigger.removeAttribute('tabindex');
        quickShopTrigger.style.pointerEvents = '';
        quickShopTrigger.style.opacity = '';
      } else {
        quickShopTrigger.classList.add('out-of-stock');
        quickShopTrigger.setAttribute('aria-disabled', 'true');
        quickShopTrigger.setAttribute('tabindex', '-1');
        quickShopTrigger.style.pointerEvents = 'none';
        quickShopTrigger.style.opacity = '0.4';
      }
    }

    function renderSizes(color) {
      sizeWrap.innerHTML = '';

      var firstAvailable = null;

      allSizeValues.forEach(function (sizeValue) {
        var variant = getVariant(color, sizeValue);
        var out = isOutOfStock(variant);
        var stock = variant ? Number(variant.inventory_quantity || 0) : 0;
        var variantId = variant ? variant.id : '';

        var span = document.createElement('span');
        span.className = 'size-option';
        span.setAttribute('data-size-value', sizeValue);
        span.setAttribute('data-size-stock', stock);
        span.setAttribute('data-variant-id', variantId);
        span.textContent = sizeValue;

        if (out) {
          span.classList.add('out-of-stock');
        } else if (!firstAvailable) {
          firstAvailable = span;
        }

        if (selectedSize === sizeValue && !out) {
          span.classList.add('is-selected');
        }

        sizeWrap.appendChild(span);
      });

      var selectedEl = sizeWrap.querySelector('.size-option.is-selected');

      if (!selectedEl && firstAvailable) {
        firstAvailable.classList.add('is-selected');
        selectedSize = firstAvailable.getAttribute('data-size-value');
      }

      syncCardSelectionData();
      updateQuickShopState();
    }

    function syncQuickShopModalVariant(modal, options) {
      if (!modal) return;

      var settings = options || {};
      var silent = settings.silent === true;

      var selectedVariantId = modal.getAttribute('data-selected-variant-id') || '';
      var selectedSizeValue = modal.getAttribute('data-selected-size') || '';
      var selectedStockValue = Number(modal.getAttribute('data-selected-stock') || 0);

      var form = modal.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      var hiddenVariantInputs = form.querySelectorAll('input[name="id"]');
      hiddenVariantInputs.forEach(function (input) {
        input.value = selectedVariantId;
        input.setAttribute('value', selectedVariantId);

        if (!silent) {
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      var modalVariantInputs = Array.prototype.slice.call(
        modal.querySelectorAll('.variant-wrapper--size .variant-input')
      );

      modalVariantInputs.forEach(function (variantEl) {
        variantEl.classList.remove('is-clicked', 'is-selected');

        var variantId = variantEl.getAttribute('data-variant-id') || '';
        var value = variantEl.getAttribute('data-value') || '';
        var radio = variantEl.querySelector('input[type="radio"]');

        var matches =
          (variantId && variantId === selectedVariantId) ||
          (selectedSizeValue && value === selectedSizeValue);

        if (matches) {
          variantEl.classList.add('is-clicked', 'is-selected');

          if (radio) {
            radio.checked = true;

            if (!silent) {
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        } else if (radio) {
          radio.checked = false;
        }
      });

      var addToCartBtn = form.querySelector('[type="submit"]');
      if (addToCartBtn) {
        if (!selectedVariantId || selectedStockValue <= 0) {
          addToCartBtn.disabled = true;
          addToCartBtn.classList.add('disabled');
        } else {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove('disabled');
        }
      }
    }

    function initQuickShopNativeVariantBlock(modal) {
      if (!modal) return;

      var productBlock = modal.querySelector('.product-block[data-dynamic-variants-enabled]');
      if (!productBlock) return;

      var variantsJsonEl = productBlock.querySelector('.product-variants-json');
      var modalColorWrap = productBlock.querySelector('.variant-input-wrap--color');
      var modalColorName = modal.querySelector('.variant-color-name');
      var modalSizeWrap = productBlock.querySelector('.variant-wrapper--size .variant-input-wrap');
      var productSection = modal.querySelector('[data-product-id]');

      if (!variantsJsonEl || !modalColorWrap || !modalSizeWrap) return;

      var modalVariants = [];
      try {
        modalVariants = JSON.parse(variantsJsonEl.textContent);
      } catch (e) {
        return;
      }

      if (productBlock.dataset.nativeQuickshopInit !== 'true') {
        productBlock.dataset.nativeQuickshopInit = 'true';

        modalColorWrap.addEventListener('click', function (e) {
          var colorEl = e.target.closest('.variant-input');
          if (!colorEl) return;

          setTimeout(function () {
            updateModalSizesByColor();
          }, 0);
        });

        modalColorWrap.addEventListener('change', function () {
          setTimeout(function () {
            updateModalSizesByColor();
          }, 0);
        });
      }

      function getModalSelectedColor() {
        var checkedRadio = modalColorWrap.querySelector('input[type="radio"]:checked');
        if (checkedRadio) return checkedRadio.value;

        var selectedColorEl = modalColorWrap.querySelector('.variant-input.is-selected, .variant-input.is-clicked');
        return selectedColorEl ? selectedColorEl.getAttribute('data-value') : null;
      }

      function getModalSelectedSizeEl() {
        return modalSizeWrap.querySelector('.variant-input.is-selected, .variant-input.is-clicked');
      }

      function getModalVariantForColorAndSize(color, size) {
        return modalVariants.find(function (variant) {
          return variant.option1 === color && variant.option2 === size;
        });
      }

      function getFirstAvailableModalVariantForColor(color) {
        return modalVariants.find(function (variant) {
          return variant.option1 === color && variant.available === true;
        }) || null;
      }

      function getInventoryQty(variantId) {
        var productId = productSection ? productSection.getAttribute('data-product-id') : null;

        if (
          productId &&
          window.inventories &&
          window.inventories[productId] &&
          window.inventories[productId][variantId]
        ) {
          return Number(window.inventories[productId][variantId].quantity || 0);
        }

        return 0;
      }

      function updateModalSizesByColor() {
        var selectedColor = getModalSelectedColor();
        if (!selectedColor) return;

        var sizeInputs = Array.prototype.slice.call(
          modalSizeWrap.querySelectorAll('.variant-input')
        );

        var firstAvailableSizeEl = null;

        sizeInputs.forEach(function (sizeEl) {
          var sizeValue = sizeEl.getAttribute('data-value');
          var radio = sizeEl.querySelector('input[type="radio"]');
          var label = sizeEl.querySelector('label');
          var matchedVariant = getModalVariantForColorAndSize(selectedColor, sizeValue);

          sizeEl.classList.remove('out-of-stock', 'unavailable', 'is-filter-hidden', 'is-disabled');

          if (label) {
            label.classList.remove('out-of-stock');
          }

          if (!matchedVariant) {
            sizeEl.classList.add('unavailable', 'is-filter-hidden');
            sizeEl.style.display = 'none';

            if (radio) {
              radio.disabled = true;
              radio.checked = false;
            }

            sizeEl.classList.remove('is-selected', 'is-clicked');
            return;
          }

          sizeEl.style.display = '';
          sizeEl.setAttribute('data-variant-id', matchedVariant.id);

          var qty = getInventoryQty(matchedVariant.id);
          var available = matchedVariant.available === true;
          var out = !available || qty <= 0;

          sizeEl.setAttribute('data-size-stock', qty);

          if (radio) {
            radio.disabled = out;
          }

          if (out) {
            sizeEl.classList.add('out-of-stock');
            if (label) {
              label.classList.add('out-of-stock');
            }
            sizeEl.classList.remove('is-selected', 'is-clicked');
            if (radio) radio.checked = false;
            return;
          }

          if (!firstAvailableSizeEl) {
            firstAvailableSizeEl = sizeEl;
          }
        });

        var currentSelected = getModalSelectedSizeEl();
        var currentStillValid =
          currentSelected &&
          currentSelected.style.display !== 'none' &&
          !currentSelected.classList.contains('out-of-stock') &&
          !currentSelected.classList.contains('unavailable');

        var activeVariant = null;

        if (!currentStillValid) {
          sizeInputs.forEach(function (el) {
            el.classList.remove('is-selected', 'is-clicked');
            var radio = el.querySelector('input[type="radio"]');
            if (radio) radio.checked = false;
          });

          if (firstAvailableSizeEl) {
            firstAvailableSizeEl.classList.add('is-selected', 'is-clicked');

            var firstRadio = firstAvailableSizeEl.querySelector('input[type="radio"]');
            if (firstRadio) {
              firstRadio.checked = true;
              firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }

            activeVariant = getModalVariantForColorAndSize(
              selectedColor,
              firstAvailableSizeEl.getAttribute('data-value')
            );
          }
        } else {
          activeVariant = getModalVariantForColorAndSize(
            selectedColor,
            currentSelected.getAttribute('data-value')
          );
        }

        if (!activeVariant) {
          activeVariant = getFirstAvailableModalVariantForColor(selectedColor);
        }

        if (activeVariant) {
          modal.setAttribute('data-selected-size', activeVariant.option2 || '');
          modal.setAttribute('data-selected-stock', getInventoryQty(activeVariant.id));
          modal.setAttribute('data-selected-variant-id', activeVariant.id);
        } else {
          modal.setAttribute('data-selected-size', '');
          modal.setAttribute('data-selected-stock', '0');
          modal.setAttribute('data-selected-variant-id', '');
        }

        syncQuickShopModalVariant(modal);

        if (modalColorName) {

        var modalColorInputs = modalColorWrap.querySelectorAll('.variant__input--color-swatch');

        // default state
        if (modalColorInputs.length === 1) {
          var singleColor = modalColorInputs[0].dataset.colorName || modalColorInputs[0].value;
          modalColorName.style.display = 'inline';
          modalColorName.textContent = singleColor;
        } 

        modalColorWrap.addEventListener('change', function(e){

          var input = e.target.closest('.variant__input--color-swatch');
          if (!input) return;

          var selectedColor = input.dataset.colorName || input.value;

          modalColorName.style.display = 'inline';
          modalColorName.textContent = selectedColor;

        });

      }
      }

      updateModalSizesByColor();
    }

    function waitAndSyncQuickShopModal(modal) {
      if (!modal) return;

      var attempts = 0;
      var maxAttempts = 30;

      var timer = setInterval(function () {
        attempts++;

        var form = modal.querySelector('form[action*="/cart/add"]');
        var jsonEl = modal.querySelector('.product-variants-json');
        var colorWrap = modal.querySelector('.variant-input-wrap--color');
        var sizeWrap = modal.querySelector('.variant-wrapper--size .variant-input-wrap');

        if (form && jsonEl && colorWrap && sizeWrap) {
          clearInterval(timer);
          syncQuickShopModalVariant(modal);
          initQuickShopNativeVariantBlock(modal);
        }

        if (attempts >= maxAttempts) {
          clearInterval(timer);
        }
      }, 150);
    }

    document.addEventListener('click', function(e){

      var colorEl = e.target.closest('.color-option');
      if (!colorEl) return;

      var colorWrap = colorEl.closest('[data-color-options]');
      if (!colorWrap) return;

      var card = colorEl.closest('[data-product-card]');

      colorWrap.querySelectorAll('.color-option').forEach(function(btn){
        btn.classList.remove('is-selected');
      });

      colorEl.classList.add('is-selected');

      var selectedColor = colorEl.getAttribute('data-color-value') || '';

      if (card) {
        card.setAttribute('data-selected-color', selectedColor);
      }

    });
    
    document.addEventListener('click', function(e){

      var sizeEl = e.target.closest('.size-option');
      if (!sizeEl) return;

      var stock = Number(sizeEl.getAttribute('data-size-stock') || 0);

      if (stock <= 0 || sizeEl.classList.contains('out-of-stock')) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      var sizeWrap = sizeEl.closest('[data-size-options]');
      if (!sizeWrap) return;

      var card = sizeEl.closest('[data-product-card]');

      sizeWrap.querySelectorAll('.size-option').forEach(function(el){
        el.classList.remove('is-selected');
      });

      sizeEl.classList.add('is-selected');

      if (card) {
        card.setAttribute('data-selected-size', sizeEl.getAttribute('data-size-value') || '');
        card.setAttribute('data-selected-stock', sizeEl.getAttribute('data-size-stock') || '');
        card.setAttribute('data-selected-variant-id', sizeEl.getAttribute('data-variant-id') || '');
      }

    });
    
    if (quickShopTrigger) {
      quickShopTrigger.addEventListener('click', function (e) {
        var selectedEl = getSelectedSizeEl();

        if (!selectedEl) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }

        var stock = Number(selectedEl.getAttribute('data-size-stock') || 0);

        if (stock <= 0 || selectedEl.classList.contains('out-of-stock')) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }

        var productId = card.getAttribute('data-product-id');
        var modal = document.querySelector('#QuickShopModal-' + productId);

        if (!modal) return;

        modal.setAttribute('data-selected-size', selectedEl.getAttribute('data-size-value') || '');
        modal.setAttribute('data-selected-stock', selectedEl.getAttribute('data-size-stock') || '');
        modal.setAttribute('data-selected-variant-id', selectedEl.getAttribute('data-variant-id') || '');

        waitAndSyncQuickShopModal(modal);
      });
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // Product Button 
  const el = document.querySelector('gravity-button.accelerated-checkout-button');
  console.log(el);

  if (el && el.shadowRoot) {
    const style = document.createElement('style');
    style.textContent = `
      :host {
        height: 36px !important;
        min-height: 36px !important;
        display: block !important;
      }

      button,
      .button,
      .button-content {
        height: 36px !important;
        min-height: 36px !important;
        max-height: 36px !important;
        box-sizing: border-box !important;
        display: flex !important;
        align-items: center !important;
      }
    `;
    el.shadowRoot.appendChild(style);
  }

  document.querySelectorAll('.variant-wrapper--color').forEach(function(wrapper){

    const colorInputs = wrapper.querySelectorAll('.variant__input--color-swatch');
    const colorName = wrapper.querySelector('.variant-color-name');

    if (!colorInputs.length || !colorName) return;

    // If only 1 color show immediately
    if (colorInputs.length === 1) {
      const singleColor = colorInputs[0].dataset.colorName || colorInputs[0].value;
      colorName.style.display = 'inline';
      colorName.textContent = singleColor;
    } else {
      colorName.style.display = 'none';
    }

    colorInputs.forEach(function(input){

      input.addEventListener('change', function(){

        const selectedColor = this.dataset.colorName || this.value;

        colorName.style.display = 'inline';
        colorName.textContent = selectedColor;

      });

    });

  });

  (function () {
    function apply() {
      const selectors = [
        'shop-pay-wallet-button',
        'shop-pay-payment-request-button',
        'gravity-button.accelerated-checkout-button'
      ];

      document.querySelectorAll(selectors.join(',')).forEach((el) => {
        el.style.setProperty('--shopify-accelerated-checkout-button-block-size', '36px', 'important');
        el.style.setProperty('--shopify-accelerated-checkout-button-border-radius', '0px', 'important');
        el.style.setProperty('display', 'block', 'important');
      });
    }

    apply();
    setInterval(apply, 100);
  })();

});


